import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectItem,
  SelectContent,
} from "../ui/select";
import { useEffect, useState, useRef } from "react";

export function ServerSelector() {
  const [server, setServer] = useState(() => {
    // Initialize server state based on current hostname
    const currentHost = window.location.hostname;
    if (currentHost === "staging.spreadfighter.com") {
      return "staging";
    } else if (currentHost === "app.spreadfighter.com") {
      return "stable";
    }
    return "stable"; // Default fallback
  });
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (location.hostname === "localhost") {
      return;
    }
    // Prevent infinite redirects
    if (hasRedirected.current) {
      return;
    }

    const currentHost = window.location.hostname;

    if (server === "staging" && currentHost !== "staging.spreadfighter.com") {
      hasRedirected.current = true;
      window.location.href = "https://staging.spreadfighter.com";
    } else if (server === "stable" && currentHost !== "app.spreadfighter.com") {
      hasRedirected.current = true;
      window.location.href = "https://app.spreadfighter.com";
    }
  }, [server]);

  return (
    <div className="w-full md:w-24">
      <Select value={server} onValueChange={setServer}>
        <SelectTrigger className="h-8 focus:ring-0 focus:ring-offset-0 text-xs px-2">
          <SelectValue placeholder="Select a server" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="stable" className="text-xs">
            Stable
          </SelectItem>
          <SelectItem value="staging" className="text-xs">
            Staging
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
